import { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";

export function useConfirm(
  text: string,
  showAtLeave: boolean = false,
  onOk: () => void = () => {},
  onCancel: () => void = () => {}
) {
  const history = useHistory();
  const [message, setMessage] = useState(text);
  const [showOnLeave, setShowOnLeave] = useState(showAtLeave);
  const actionsRef = useRef({ onOk: onOk, onCancel: onCancel });

  const showConfirmationAlert = () => {
    if (window.confirm(message) === true) {
      actionsRef.current.onOk();
    } else {
      actionsRef.current.onCancel();
    }
  };

  const setOnOk = (onOk: () => void) => {
    actionsRef.current.onOk = onOk;
  };
  const setOnCancel = (onCancel: () => void) => {
    actionsRef.current.onCancel = onCancel;
  };

  useEffect(() => {

    const unblock = history.block((tx) => {
      if(showOnLeave){
        if (window.confirm(message) === true) {
          actionsRef.current.onOk();
          unblock();
          history.push(tx);
        } else {
          actionsRef.current.onCancel();
          return false;
        }
      }
    });

    return unblock;
  }, [showOnLeave, message]);

  return {
    showConfirmationAlert,
    setMessage,
    setShowOnLeave,
    setOnOk,
    setOnCancel,
  };
}

export function useAlert() {
  const showAlert = (message: string) => {
    window.alert(message);
  };

  return { showAlert };
}
